import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { R_SIGNON } from 'app/Auth/lib'
import { useNav } from 'app/Nav'
import GlobalContext from 'reducer/global'

export function AuthSignOut() {
  useNav('user')
  const [, dispatch] = useContext(GlobalContext)
  const navigate = useNavigate()

  useEffect(() => {
    dispatch({ type: R_SIGNON.SIGN_OUT })
    navigate('/auth/signon', { replace: true })
  }, [dispatch, navigate])

  return null
}
